const PlayIcon = ({ width = 40, height = 40, color = "#000000" }) => {
  return (
    <svg
      fill={color}
      width={width}
      height={height}
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M175 .024V1920l1570.845-959.927z" fillRule="evenodd" />
    </svg>
  );
};

export default PlayIcon;
